export default __webpack_public_path__ + "static/media/php.10799c01.svg";